// ApexCharts `tooltip.custom` expects an HTML string; pair with chartTooltipStyles.
export function buildChartTooltip ({ label, count, sublabel, color }) {
  const dotStyle = color ? ` style="background:${color}"` : '';
  const labelStyle = color ? ` style="color:${color}"` : '';
  return `
    <div class="chartTooltip">
      <div class="chartTooltip__head">
        <span class="chartTooltip__dot"${dotStyle}></span>
        <span class="chartTooltip__label"${labelStyle}>${label}</span>
      </div>
      <div class="chartTooltip__count">${count}</div>
      <div class="chartTooltip__sublabel">${sublabel}</div>
    </div>`;
}

export function buildMultiSeriesChartTooltip ({ title, items }) {
  const rows = items.map(({ label, count, color }) => {
    const dotStyle = color ? ` style="background:${color}"` : '';
    const labelStyle = color ? ` style="color:${color}"` : '';
    return `
      <div class="chartTooltip__row">
        <div class="chartTooltip__rowLabel">
          <span class="chartTooltip__dot"${dotStyle}></span>
          <span class="chartTooltip__label"${labelStyle}>${label}</span>
        </div>
        <span class="chartTooltip__rowCount">${count}</span>
      </div>`;
  }).join('');
  return `
    <div class="chartTooltip chartTooltip--multi">
      <div class="chartTooltip__title">${title}</div>
      ${rows}
    </div>`;
}
